(function($) {
	$( '.tiles.slider' ).slick(
		{
			dots: true,
			infinite: false,
			slidesToShow: 3,
			slidesToScroll: 3,

			responsive: [{
				breakpoint: 1024,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 2
				}
			},
			{
				breakpoint: 568,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1
				}
			}
			]
		}
	);
}(jQuery));
